import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import * as L from 'leaflet';
import { latLng, LeafletMouseEvent } from 'leaflet';
import 'leaflet.markercluster';
import { concat, of as observableOf, combineLatest, from, of, Subscription, Observable, Subject } from 'rxjs';
import { catchError, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { DataService } from '../../services/data.service';
import { UserService } from '../../services/user.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { RespondTicketComponent } from '../modals/respond-ticket/respond-ticket.component';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { AppConfig } from "../../app.config";
import { StreetViewService } from '../../services/street-view.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import 'leaflet.gridlayer.googlemutant';
import { TicketImagesModalComponent } from '../modals/ticket-images/ticket-images-modal.component';
import _ from "lodash";
import { GeocodingService } from '../../services/geocoding.service';
import 'leaflet-control-geocoder';
import { environment } from "../../../environments/environment";
import { ErrorModalComponent } from '../modals/error-modal/error-modal.component';
// import { files } from './example-data';

// import { files } from './example-data';

/** File node data with nested structure. */
export interface FileNode {
  name: string;
  type: string;
  image: string;
  children?: FileNode[];
}

/** Flat node with expandable and level information */
export interface TreeNode {
  name: string;
  type: string;
  image: string;
  level: number;
  expandable: boolean;
}

export interface ProjectDetails {
  projectData:any;
  projectScheme:any;
}

const createButton = (label, container) => {
  const btn = L.DomUtil.create('button', '', container);
  btn.setAttribute('type', 'button');
  btn.innerHTML = label;
  return btn;
};

@Component({
  selector: 'app-map',
  templateUrl: './public-map.component.html',
  styleUrls: ['./public-map.component.scss'],
  animations: [
    trigger('OpenClose', [
      state('initial', style({
        left: "0"
      })),
      state('final', style({
        left: "500px"
      })),
      transition('initial=>final', animate('250ms')),
      transition('final=>initial', animate('250ms'))
    ]),
    trigger('OpenCloseSidebar', [
      state('initial', style({
        left: "-500px"
      })),
      state('final', style({
        left: "0"
      })),
      transition('initial=>final', animate('250ms')),
      transition('final=>initial', animate('250ms'))
    ]),
  ]
})

export class PublicMapComponent implements OnInit, AfterViewInit {

  public _opened: boolean = false;
  public currentState: string = 'initial';

  public _routeSearchOpened: boolean = false;
  public currentRouteSearchState: string = 'initial';

  public transportType: string = 'foot';

  toolTip: {
    'className': 'class-tooltip'
  };

  public _toggleSidebar() {
    this._opened = !this._opened;
    if (this._opened) this.currentState = 'final';
    else this.currentState = 'initial';
  }

  public _toggleRouteSearch() {
    this._routeSearchOpened = !this._routeSearchOpened;
    if (this._routeSearchOpened) {
      this.currentRouteSearchState = 'final';
    } else {
      this.currentRouteSearchState = 'initial';
      if (this.routing) {
        const waypoints = this.routing.getWaypoints();
        this.routing.spliceWaypoints(0, waypoints.length);
      }
    }
  }

  public selectedReport = { image: [] };

  optShown = false;
  popupShown = false;

  leafletOptions: any;
  layers: any[];

  projectId: number;

  projectData:ProjectDetails;
  schoolData = [];

  private map: L.DrawMap;

  markerCluster;
  schoolMarkerCluster;

  private oldActiveMarker;
  private oldImgMarker;

  legend: any[] = [];
  flattenLegend: any[] = [];
  markerPopup: any;
  commonMarkerPopup: any;

  commonPopupShown = false;

  oldMarkerIconSize: [number, number];
  oldMarkerIconAnchor: L.Point;

  dict: any;
  mapLoading: Subscription;
  private checksum: any;

  /** The TreeControl controls the expand/collapse state of tree nodes.  */
  treeControl: FlatTreeControl<TreeNode>;

  /** The TreeFlattener is used to generate the flat list of items from hierarchical data. */
  treeFlattener: MatTreeFlattener<FileNode, TreeNode>;

  /** The MatTreeFlatDataSource connects the control and flattener to provide data. */
  dataSource: MatTreeFlatDataSource<FileNode, TreeNode>;

  engFiles: FileNode[] = [
    {
      name: 'Biking to school',
      type: 'section',
      image: 'assets/img/topic/2.jpg',
      children: [
        {
          name: 'It’s good for you and the environment',
          type: 'topic',
          image: '',
          children: [
            {
              name: `There are lots of personal and community benefits of biking to school, including increased physical activity, reduced traffic congestion, safer streets and neighbourhoods, improved air quality, and fewer greenhouse gas emissions.`,
              'type': 'content',
              image: 'assets/img/topic/4.jpg'
            }
          ]
        },
        {
          name: 'Safety first',
          type: 'topic',
          image: '',
          children: [
            {
              name: `Riding your bike to school? Make sure you stay safe and visible by keeping your bike clean and in good repair, using front and rear lights on your bike when it’s dark out, and always wearing a helmet. Also, remember to follow the rules of the road - you are a vehicle, too!`,
              'type': 'content',
              image: 'assets/img/topic/5.png',
            }
          ]
        },
        {
          name: 'Biking School Bus',
          type: 'topic',
          image: '',
          children: [
            {
              name: `Get one or more families together to bike to school in a group, and you’ve got a biking school bus! This gives kids a chance to get outside and get some exercise at the beginning and the end of the school day while fostering community, safety, and eco-friendly habits. Volunteer parents who live on the same block or in the same apartment building can start out biking with the group, sharing responsibility and building social networks along the way. Later, as trust is built and schedules are organized, taking turns can save time.`,
              'type': 'content',
              image: 'assets/img/topic/6.png',
            }
          ]
        },
        {
          name: 'Learn more',
          type: 'topic',
          image: '',
          children: [
            {
              name: `Interested in learning more about Active and Safe Routes to School? Check out the resources on Green Action Centre’s website <a href="https://greenactioncentre.ca/asrts/">here</a>`,
              'type': 'content',
              image: 'assets/img/topic/7.png',
            }
          ]
        },
      ]
    },
    {
      name: 'Walking to school',
      type: 'section',
      image: 'assets/img/topic/3.jpg',
      children: [
        {
          name: 'It’s good for you and the environment',
          type: 'topic',
          image: '',
          children: [
            {
              name: `There are lots of personal and community benefits of walking to school, including increased physical activity, reduced traffic congestion, safer streets and neighbourhoods, improved air quality, and fewer greenhouse gas emissions.`,
              type: 'content',
              image: 'assets/img/topic/9.jpg',
            },
          ]
        },
        {
          name: 'Walking School Bus',
          type: 'topic',
          image: '',
          children: [
            {
              name: `Families who live on the same block, or in the same apartment building, walk children to and from school. Initially everybody walks, sharing responsibility and conversation and building social networks along the way. Later, as trust is built and schedules get organized, taking turns can save time. Read about one parent’s experience <a href="https://greenactioncentre.ca/healthy-travel/building-community-a-walking-school-bus-story/">here</a>`,
              type: 'content',
              image: 'assets/img/topic/10.jpg',
            },
          ]
        },
        {
          name: 'Walking Wednesdays',
          type: 'topic',
          image: '',
          children: [
            {
              name: `Try walking to school once a week by starting a Walking Wednesdays club. Get your whole school involved - the more the merrier. Promoting walking to school once a week throughout the entire year can be a great way to form positive habits that continue into the summer, the following school year and maybe even for a lifetime!`,
              type: 'content',
              image: 'assets/img/topic/11.png',
            },
          ]
        },
        {
          name: 'Learn more',
          type: 'topic',
          image: '',
          children: [
            {
              name: `Interested in learning more about Active and Safe Routes to School? Check out the resources on Green Action Centre’s website <a href="https://greenactioncentre.ca/asrts/">here</a>`,
              type: 'content',
              image: 'assets/img/topic/11.png',
            },
          ]
        }
      ]
    },
    {
      name: 'Driving to school',
      type: 'section',
      image: 'assets/img/topic/1.jpg',
      children: [
        {
          name: 'It starts with you',
          type: 'topic',
          image: '',
          children: [
            {
              name: `Help end the cycle of driving! If families don’t feel confident that their children are safe while walking, biking, or skating to school, they aren’t inclined to let them. This creates a cycle in which fewer and fewer children are on the street and drivers are inclined to move faster because there seems to be nobody around. Try getting your kids to school by foot or by bike whenever possible. Let’s end the cycle by making streets safe, and children can start using them.`,
              type: 'content',
              image: 'assets/img/topic/12.jpg',
            }
          ]
        },
        {
          name: 'School Streets',
          type: 'topic',
          image: '',
          children: [
            {
              name: `Ask your local school/government to consider implementing a School Street! This means a street is closed to vehicles in front of the school to support children’s health and safety by addressing road safety issues, increasing daily physical activity, and providing additional safe outdoor space for physical distancing. Read about Green Action Centre’s pilot School Street <a href="https://greenactioncentre.ca/healthy-travel/school-streets-update/">here</a>`,
              type: 'content',
              image: 'assets/img/topic/12.jpg',
            }
          ]
        },
        {
          name: 'Slow down for school zones',
          type: 'topic',
          image: '',
          children: [
            {
              name: `Pedestrians have been shown to have a 90% chance of survival when struck by a car travelling at 30 km/h or below, but less than 50% chance of surviving an impact at 45 km/h. By driving slower you can prevent crashes and reduce the severity of injuries if there is a collision. Every km/h slower has an impact.`,
              type: 'content',
              image: 'assets/img/topic/12.jpg',
            }
          ]
        }
      ]
    }
  ];

  nldFiles: FileNode[] = [
    {
      name: 'Ik ga met de fiets naar school',
      type: 'section',
      image: 'assets/img/topic/2.jpg',
      children: [
        {
          name: 'Gezond, leuk, snel en duurzaam',
          type: 'topic',
          image: '',
          children: [
            {
              name: `Het is leuker, sneller en gezonder. Je slaapt er beter van. Het is gezellig samen met vrienden. Het is duurzaam: beter voor het milieu en het klimaat. Het maakt je slimmer; je hersenen werken er beter door`,
              'type': 'content',
              image: 'assets/img/topic/4.jpg'
            }
          ]
        },
        {
          name: 'Wat is een fietsstraat ?',
          type: 'topic',
          image: '',
          children: [
            {
              name: `Een Fietsstraat is een straat die ingericht is als fietsroute, maar waarop ook auto’s zijn toegestaan. Fietsers worden uitgenodigd om over de volle breedte van de rijbaan (in hun rijrichting) te rijden. Auto’s mogen fietsers niet inhalen en mogen niet sneller dan 30 km/u rijden.`,
              'type': 'content',
              image: 'assets/img/topic/5.png',
            }
          ]
        },
        {
          name: 'Wat is de “dode hoek” ?',
          type: 'topic',
          image: '',
          children: [
            {
              name: `De dode hoek is de ruimte rond een vrachtwagen of autobus waarbinnen fietsers en voetgangers niet zichtbaar zijn voor de chauffeur. Dit is bijzonder gevaarlijk. Tips om de dode hoek te vermijden: <div>– Ga nooit dicht tegen een vrachtwagen of bus staan. Maak dat de bestuurder je steeds kan zien door zijn raam of in de spiegel. Als jij de bestuurder ziet, dan kan hij jou ook zien!</div><div>– Afslaande voertuigen op kruispunten maar ook aan garages, opritten en parkings merken  fietsers en voetgangers niet of vaak te laat op door hun dode hoek. Maak steeds oogcontact met de bestuurder.</div><div>– Blijf op een kruispunt rechts achter de vrachtwagen of bus.</div>`,
              'type': 'content',
              image: 'assets/img/topic/6.png',
            }
          ]
        },
        {
          name: 'Zorg dat je zichtbaar bent',
          type: 'topic',
          image: '',
          children: [
            {
              name: `Zorg dat voorlicht en achterlicht goed werken. Gebruik ze ook, zeker ook als het overdag donkerder is. Zorg dat je fiets alle reflectoren heeft die nodig zijn. Draag een hesje, zeker als het donker is.`,
              'type': 'content',
              image: 'assets/img/topic/7.png',
            }
          ]
        },
        {
          name: 'Hou je fiets en jezelf in orde',
          type: 'topic',
          image: '',
          children: [
            {
              name: `Zorg dat je fiets schoon is dan gaat hij minder snel kapot en zie je er proper uit Zorg dat je een goed slot op je fiets hebt en gebruik dat ook altijd. Draag een helm en een hesje zodat ze je beter zien en je hoofd goed beschermd is.`,
              'type': 'content',
              image: 'assets/img/topic/8.jpg',
            },
          ]
        }
      ]
    },
    {
      name: 'Ik ga met de auto naar school',
      type: 'section',
      image: 'assets/img/topic/1.jpg',
      children: [
        {
          name: 'Stilstaan en parkeren',
          type: 'topic',
          image: '',
          children: [
            {
              name: `Stilstaan en parkeren mag enkel waar dat toegelaten is, ook al is het maar voor eventjes! In dubbele file parkeren, parkeren aan een bushalte, op het fietspad, op een zebrapad of op de stoep is verboden. Fout geparkeerde wagens brengen kinderen in gevaar. Ze belemmeren het zicht zodat overstekende kinderen het extra moeilijk hebben om het andere verkeer te zien en zelf ook niet goed gezien worden. Voetgangers en fietsers worden bovendien vaak gedwongen om uit te wijken naar de rijbaan, waar ze meer gevaar lopen. Let er ook altijd goed op dat er zich geen kind voor of achter je wagen bevindt als je vertrekt of manoeuvreert.`,
              type: 'content',
              image: 'assets/img/topic/9.jpg',
            },
          ]
        },
        {
          name: 'Carpooling',
          type: 'topic',
          image: '',
          children: [
            {
              name: `Al eens gedacht aan carpooling? Ook met de auto kan je ervoor zorgen dat er minder verkeer is en het er veiliger op wordt voor de voetgangers en fietsers! Als meerdere kinderen van verschillende gezinnen samen rijden, zijn er minder auto’s op de weg naar school.`,
              type: 'content',
              image: 'assets/img/topic/10.jpg',
            },
          ]
        },
        {
          name: 'Kiss and Ride',
          type: 'topic',
          image: '',
          children: [
            {
              name: `In deze zones geldt er eigenlijk een parkeerverbod: je mag er enkel stilstaan de tijd die nodig is om goederen te laden en te lossen en personen te laten in- en uitstappen. Je auto parkeren in deze zone en mee naar binnen gaan in de school mag dus niet. De Kiss and Ride zones zijn enkel voorzien om kinderen dicht bij de schoolpoort te laten in- en uitstappen. En om dan opnieuw te vertrekken, zodat er een plaatsje vrij komt voor de volgende ouder.`,
              type: 'content',
              image: 'assets/img/topic/11.png',
            },
          ]
        }
      ]
    },
    {
      name: 'Ik ga te voet naar school',
      type: 'section',
      image: 'assets/img/topic/3.jpg',
      children: [
        {
          name: 'Waar het beste stappen ?',
          type: 'topic',
          image: '',
          children: [
            {
              name: `Waar stap je als voetganger?<div>– Trottoir</div><div>– Verhoogde berm</div><div>– Voorbehouden plaatsen, aangeduid met een verkeersbord Waar kan ik lopen als deze niet aanwezig zijn?</div><div>– Gelijkgrondse berm</div><div>– Parkeerzones</div><div>– Fietspaden (opgelet! bromfietsers hebben hier voorrang)`,
              type: 'content',
              image: 'assets/img/topic/12.jpg',
            }
          ]
        },
        {
          name: 'Wat is de “dode hoek” ?',
          type: 'topic',
          image: '',
          children: [
            {
              name: `Empty`,
              type: 'content',
              image: 'assets/img/topic/12.jpg',
            }
          ]
        }
      ]
    }
  ];

  tiles: any[] = [];
  currentTileIdx: number = 1;

  projectRegistry: any[] = [];

  public provinceIcon;
  public cityIcon;

  address$: Observable<any[]>;
  addressLoading = false;
  addressInput$ = new Subject<string>();

  start$: Observable<any[]>;
  startLoading = false;
  startInput$ = new Subject<string>();

  destination$: Observable<any[]>;
  destinationLoading = false;
  destinationInput$ = new Subject<string>();

  startPoint;
  destinationPoint;

  startMarker;
  destinationMarker;
  routing;

  public iframeAvailable: boolean = false;
  showPublicMapSidebar= environment.publicMapSidebar;
  showRouterMarker:boolean = false;
  constructor(
    private cd: ChangeDetectorRef,
    private dataService: DataService,
    private modalService: NgbModal,
    private userService: UserService,
    private config: AppConfig,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private appConfig: AppConfig,
    private gsv: StreetViewService, // DO NOT REMOVE!
    private geocodingService: GeocodingService,
  ) {
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren);

    this.treeControl = new FlatTreeControl<TreeNode>(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  }

  get lang(): string {
    return this.translate.currentLang;
  }

  set lang(value: string) {
    localStorage.setItem('user_lng', value);
    this.translate.use(value);
  }

  /** Transform the data to something the tree can read. */
  transformer(node: FileNode, level: number) {
    return {
      name: node.name,
      type: node.type,
      image: node.image,
      level: level,
      expandable: !!node.children
    };
  }

  /** Get the level of the node */
  getLevel(node: TreeNode) {
    return node.level;
  }

  /** Return whether the node is expanded or not. */
  isExpandable(node: TreeNode) {
    return node.expandable;
  };

  /** Get the children for the node. */
  getChildren(node: FileNode) {
    return observableOf(node.children);
  }

  /** Get whether the node has children or not. */
  hasChild(index: number, node: TreeNode) {
    return node.expandable;
  }

  ngOnInit() {

    const browserLang = this.translate.getBrowserLang();

    console.log(browserLang);

    this.translate.onLangChange.subscribe((e) => {

      const leafletRoutingGeoCoders = document.querySelectorAll('.publicmap .leaflet-routing-geocoders .leaflet-routing-geocoder');

      if (leafletRoutingGeoCoders && leafletRoutingGeoCoders.length > 1) {
        leafletRoutingGeoCoders[0].querySelector('input').placeholder = this.translate.instant('Choose starting point, or click on the map');
        leafletRoutingGeoCoders[leafletRoutingGeoCoders.length - 1].querySelector('input').placeholder = this.translate.instant('Choose destination...');
      }

      if (e.lang === 'NLD') {
        this.dataSource.data = this.nldFiles;
      } else {
        this.dataSource.data = this.engFiles;
      }
    });

    const tileLayerOptions = {
      // attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      maxZoom: 18,
      id: 'mapbox.streets',
      accessToken: 'pk.eyJ1IjoiYW50b242Mzc4IiwiYSI6IlBtMG5pMjgifQ.bGiCZKEStTnO5YjSzmkJZg'
    };

    this.tiles = [
      // tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', tileLayerOptions),
      // @ts-ignore
      L.gridLayer.googleMutant({ type: 'satellite' }),
      this.appConfig.getTileLayer()
    ];

    this.leafletOptions = {
      layers: [
        this.tiles[1]
      ],
      zoom: 14,
      center: latLng(50.848656786354994, 4.349341392517091)
    };

    this.map = L.map('map', this.leafletOptions);
    this.map.zoomControl.setPosition('topright');
    // @ts-ignore
    this.markerCluster = L.markerClusterGroup({
      spiderfyOnMaxZoom: true,
      showCoverageOnHover: false,
      iconCreateFunction: this.clusterIcon,
    });

    // @ts-ignore
    this.schoolMarkerCluster = L.markerClusterGroup({
      spiderfyOnMaxZoom: true,
      showCoverageOnHover: false,
      iconCreateFunction: this.schoolClusterIcon,
    });

    this.map.addLayer(this.markerCluster);
    this.map.addLayer(this.schoolMarkerCluster);

    this.activatedRoute.params
      .subscribe(params => {
        let path = params.project;

        if (params.subproject) {
          path += `/${params.subproject}`;
        }

        this.getLegend(path);
      });

    this.activatedRoute.queryParamMap.subscribe((map) => {
      const iFrame = map.get('iframe');

      if (iFrame === 'true') {
        this.iframeAvailable = true;
      }
    });

    this.map.on('click', this.onClickHandler.bind(this))
    this.map.on("mousedown", (clickEvent: LeafletMouseEvent) => {
      const initialCenter = this.map.getCenter();
      const handler = () => {
        const newCenter = this.map.getCenter();
        const distance = initialCenter.distanceTo(newCenter);
        const zoom = this.map.getZoom();
        const maxZoom = this.map.getMaxZoom();
        const zoomScale = this.map.getZoomScale(zoom, maxZoom);
        // console.log('Zoom scale: ', zoomScale);

        const ratio = distance * zoomScale;
        // console.log('Distance: ', distance, '; Zoom: ', zoom, '; Ratio: ', ratio);
        if (distance > 0 && ratio < 5) {
          // console.log('Fire click');
          // const marker = L.marker(clickEvent.latlng);
          // this.markerCluster.addLayer(marker);
          this.onClickHandler(clickEvent);
        }
        this.map.removeEventListener("mouseup", handler);
      };
      this.map.on("mouseup", handler);
    });

    this.initTypeahead();

    this.locateRouteControl();
  }

  ngAfterViewInit(): void {
    console.log(this.map);
    setTimeout(() => {
      this.map.invalidateSize();
    }, 0);
    // this.map.invalidateSize();
  }

  onClickHandler(event) {
    if (this._routeSearchOpened) {
      const waypoints = this.routing.getWaypoints();
      let start = waypoints[0];
      let end = waypoints[waypoints.length - 1];

      let points = [];
      let change = false;
      if (!start.latLng) {
        start = L.Routing.waypoint(event.latlng);
        change = true;
        console.log(start.latLng);
      }

      if (!change && !end.latLng) {
        end = L.Routing.waypoint(event.latlng);
        change = true;
        console.log(end.latLng);
      }

      if (change) {
        points = [start, end];
        this.routing.setWaypoints(points);
      }
    }
  }

  toggleOptions() {
    this.optShown = !this.optShown;
  }

  toggleMapType() {
    try {
      this.tiles[this.currentTileIdx].removeFrom(this.map);
    } catch { }
    // this.currentTileIdx = this.currentTileIdx == 2 ? 0 : this.currentTileIdx + 1;
    this.currentTileIdx = this.currentTileIdx == 1 ? 0 : this.currentTileIdx + 1;
    this.tiles[this.currentTileIdx].addTo(this.map);
  }

  closePopup() {
    this.popupShown = false;
    this.commonPopupShown = false;
  }

  respondTicket(ticket) {
    this.dataService
      .isLikedTicket(ticket.projectID.id, ticket.entityID.id2)
      .pipe(
        switchMap(isLike => {
          const dlg = this.modalService.open(RespondTicketComponent);
          dlg.componentInstance.isLiked = isLike;
          dlg.componentInstance.isLikedAlready = isLike;
          return from(dlg.result);
        }),
        switchMap(dlgAnswer => {
          if (!dlgAnswer.isLikedAlready && dlgAnswer.like) {
            this.dataService.likeTicket(ticket.projectID.id, ticket.entityID.id2).subscribe(() => of(dlgAnswer));
          } else {
            return of(dlgAnswer);
          }
        }),
        switchMap(dlgAnswer => {
          return this.dataService.addMessageToTicket(ticket.projectID.id, ticket.entityID.id2, dlgAnswer.msg);
        })
      )
      .subscribe(response => console.log(response));
  }

  getLegend(path) {

    this.mapLoading = this.dataService.getFreeProjectChecksum(path).pipe(
      switchMap(result => {
        this.checksum = result.checksum;
        this.projectId = result.id;

        return combineLatest([
          this.dataService.getPubDictionary('ENG', result.checksum, result.id),
          this.dataService.getPublicLayerSets(result.id, result.checksum),
          this.dataService.getPublicLayers(result.id, result.checksum),
          this.dataService.getPublicProjectData(result.id, result.checksum),
          this.dataService.getPublicProjectIcons(result.id, result.checksum)
        ]);
      }),
      switchMap((/*[dict, layerSets, layers, genRoutes]*/data) => {
        // console.log('genroutes', genRoutes.filter(r => r.segments.length > 1));
        const dict = data[0];
        const layerSets = data[1];
        const layers = data[2];
        const project = data[3];
        this.projectData = project;
        const icons = data[4];
        this.showRouterMarker=this.projectData.projectData.safeRouterEnabled;
        try {
          this.provinceIcon = icons[0] ? { 'background-image': 'url(' + `${this.config.getHost()}/api2/public/image?image_id=${icons[0].id}&dimension=250` + ')' } : null;
          this.cityIcon = icons[1] ? { 'background-image': 'url(' + `${this.config.getHost()}/api2/public/image?image_id=${icons[1].id}&dimension=250` + ')' } : null;
        } catch {

        }
        const center = _.cloneDeep(project.projectData.center);
        const pos = latLng(center.coordinates.reverse())
        this.map.panTo(pos);

        const genRoutes = null;
        // const genRoutes = data[3];
        this.legend = [];

        this.dict = dict;
        if ('map' in this.dict) {
          this.translate.setTranslation('ENG', this.dict['map'], true);
        }

        const entities$ = [];

        layerSets.forEach(s => {
          this.legend.push({
            value: true,
            name: `set_${s.layerSetID.id2}`,
            setId: s.layerSetID.id2,
            label: dict.map[s.name.toLowerCase()],
            icon: s.icon.id,
            children: [],
            no_icon: ['LS_TICKETS', 'LS_ROUTES'].includes(s.name)
          });
        });

        /**
         * Get Routes GenRoutes layers
         */

        const mapLayers = [];
        let mapRouteslayer, mapGenRoutesLayer;
        Object.keys(layers).forEach(k => {
          layers[k].forEach(l => {
            if (l.name === 'Routes') {
              mapRouteslayer = l;
            } else if (l.name === 'GenRoutes') {
              mapGenRoutesLayer = l;
            } else {
              mapLayers.push(l);
            }
          });
        });

        /**
         * Fetch genRoutes
         */
        let routesSetId = null;
        let routesLegend = null;

        if (mapRouteslayer.layer_set_id) {
          routesSetId = mapRouteslayer.layer_set_id.id2;
          routesLegend = this.legend.find(s => s.setId == mapRouteslayer.layer_set_id.id2).children;
        }


        if (mapGenRoutesLayer.style_descriptor.dynamic_color && mapRouteslayer.style_descriptor.dynamic_color && routesSetId) {

          let colorMap = null;
          let iconMap = null;
          const tagMap = {};

          const genLegends = [];

          let projectId = this.projectId;
          let projectIdOrScheme = mapGenRoutesLayer.layerID.id1.id

          colorMap = mapGenRoutesLayer.style_descriptor.dynamic_color.map;

          let projectPath = path;

          Object.keys(colorMap).forEach(k => {
            const item = {
              value: true,
              name: `layer_${mapGenRoutesLayer.default_entity_type}_${mapGenRoutesLayer.layerID.id2}_${k}`,
              routesSetId,
              label: dict.map[k.toLowerCase()],
              line: colorMap[k],
              target: this.map,
              entities: []
            };
            tagMap[k] = item.entities;
            genLegends.push(item);

          });

          let genroutes$ = this.dataService.getPublicEntitiesInLayer(mapGenRoutesLayer.checksum, mapGenRoutesLayer.layerID.id2, projectPath, projectId, projectIdOrScheme);
          let routes$ = this.dataService.getPublicEntitiesInLayer(mapRouteslayer.checksum, mapRouteslayer.layerID.id2, projectPath, projectId, projectIdOrScheme);

          entities$.push(genroutes$.pipe(
            catchError(() => of('err')),
            tap((result: any[] | string) => {
              if (!Array.isArray(result)) {
                if (result === 'err') {
                }
              } else {
                if (result && result.length) {
                  genLegends.forEach(gLegend => {
                    this.flattenLegend.push(gLegend);
                    routesLegend.push(gLegend);
                  });

                  result.forEach(e => {
                    e.segments.forEach(s => {
                      let attrs = s.genericAttributes.attributes;
                      let key = attrs.accessibility[0];

                      const hidden = attrs.invisible_in_project
                        && attrs.invisible_in_project.length > 0
                        && attrs.invisible_in_project.indexOf(this.projectId) >= 0;

                      let polyline = this.poly(attrs, colorMap[key], !hidden);
                      polyline.addTo(this.map);
                      tagMap[key].push(polyline);
                    });
                  });
                }
              }
            }),
            switchMap(result => {
              if (result && result.length) {
                return of([]);
              } else {
                return routes$;
              }
            }),
            tap(result => {
              if (result && result.length) {
                colorMap = mapRouteslayer.style_descriptor.dynamic_color.map;


                Object.keys(colorMap).forEach(k => {
                  const item = {
                    value: mapRouteslayer.default_visible,
                    name: `layer_${mapRouteslayer.default_entity_type}_${mapRouteslayer.layerID.id2}_${k}`,
                    routesSetId,
                    label: dict.map[k.toLowerCase()],
                    line: colorMap[k],
                    target: this.map,
                    entities: []
                  };
                  tagMap[k] = item.entities;
                  this.flattenLegend.push(item);
                  routesLegend.push(item);
                });

                result.forEach(e => {
                  e.segments.forEach(s => {
                    let attrs = s.genericAttributes.attributes;
                    let key = attrs.accessibility[0];

                    const hidden = attrs.invisible_in_project
                      && attrs.invisible_in_project.length > 0
                      && attrs.invisible_in_project.indexOf(this.projectId) >= 0;

                    let polyline = this.poly(attrs, colorMap[key], !hidden);
                    if (mapRouteslayer.default_visible) polyline.addTo(this.map);
                    tagMap[key].push(polyline);
                  });
                });
              }
            })
          ));
        }

        mapLayers.forEach(l => {
          let setId = null;
          let legend = null;

          if (l.layer_set_id) {
            setId = l.layer_set_id.id2;
            legend = this.legend.find(s => s.setId == l.layer_set_id.id2).children;
          } else {
            legend = this.legend;
          }

          let colorMap = null;
          let iconMap = null;
          const tagMap = {};

          let projectId = this.projectId;
          let projectIdOrScheme = l.layerID.id1.id

          // if (l.layerID.id1["@class"] == 'be.imob.mm.domain.member.ProjectID') {
          //   // projectId = l.layerID.id1.id;
          // }

          let projectPath = path;

          if (l.style_descriptor.dynamic_icon && setId) {
            iconMap = l.style_descriptor.dynamic_icon.map;
            Object.keys(iconMap).forEach(k => {
              const item = {
                value: l.default_visible,
                name: `layer_${l.default_entity_type}_${l.layerID.id2}_${k}`,
                setId,
                label: dict.map[k.toLowerCase()],
                icon: `assets/img/${iconMap[k]}`,
                target: this.markerCluster,
                entities: []
              };
              tagMap[k] = item.entities;
              legend.push(item);
              this.flattenLegend.push(item);
            });
            entities$.push(this.dataService.getPublicEntitiesInLayer(l.checksum, l.layerID.id2, projectPath, projectId, projectIdOrScheme).pipe(
              catchError(() => of('err')),
              tap((result: any[] | string) => {
                if (!Array.isArray(result)) {
                  if (result === 'err') {
                    console.log(result)
                  }
                } else {
                  result.forEach(e => {
                    const attrs = Object.assign({ entityID: e.entityID }, { projectID: e.projectID }, e.genericAttributes.attributes);
                    const key = attrs.status[0];
                    const marker = this.marker(attrs, iconMap[key], e.timeStamp);

                    if (l.default_visible) this.markerCluster.addLayer(marker);

                    tagMap[key].push(marker);
                  });
                }
              })
            ));


          } else if (l.style_descriptor.dynamic_color && setId) {
            colorMap = l.style_descriptor.dynamic_color.map;

            Object.keys(colorMap).forEach(k => {
              const item = {
                value: l.default_visible,
                name: `layer_${l.default_entity_type}_${l.layerID.id2}_${k}`,
                setId,
                label: dict.map[k.toLowerCase()],
                line: colorMap[k],
                target: this.map,
                entities: []
              };
              tagMap[k] = item.entities;
              this.flattenLegend.push(item);
              legend.push(item);
            });

            let routes$ = this.dataService.getPublicEntitiesInLayer(l.checksum, l.layerID.id2, projectPath, projectId, projectIdOrScheme);

            entities$.push(routes$.pipe(
              catchError(() => of('err')),
              tap((result: any[] | string) => {
                if (!Array.isArray(result)) {
                  if (result === 'err') {
                    console.log(result)
                  }
                } else {
                  result.forEach(e => {
                    e.segments.forEach(s => {
                      let attrs = s.genericAttributes.attributes;
                      let key = attrs.accessibility[0];

                      const hidden = attrs.invisible_in_project
                        && attrs.invisible_in_project.length > 0
                        && attrs.invisible_in_project.indexOf(this.projectId) >= 0;

                      let polyline = this.poly(attrs, colorMap[key], !hidden);
                      if (l.default_visible) polyline.addTo(this.map);
                      tagMap[key].push(polyline);
                    });
                  });
                }
              })
            ));
          } else if (l.name !== 'GenRoutes' && (
            l.default_geom_type === 'LINEAL' ||
            l.default_geom_type === 'PUNTAL' ||
            l.default_geom_type === 'POLYGONAL')) {
            let key = l.name.toLowerCase();
            iconMap = l.style_descriptor;

            let item = {
              value: l.default_visible,
              name: `layer_${l.default_entity_type}_${l.layerID.id2}_${key}`,
              setId: setId,
              key: key,
              label: l.name,
              target: null,
              entities: []
            };
            if (l.default_geom_type === 'PUNTAL') {
              item['icon'] = `assets/img/${(iconMap.style_point || {}).icon}`;
            } else if (l.default_geom_type === 'LINEAL') {
              item['line'] = (iconMap.style_line || {}).color;
            } else if (l.default_geom_type === 'POLYGONAL') {
              item['line'] = (iconMap.style_polygon || {}).color;
            }

            let icon = (iconMap.style_point || {}).icon;
            let commonCluster = null;
            if (l.name === 'Scholen') {
              icon = 'office.png';
              item['icon'] = `assets/marker/office.png`;
            } else {
              // Common Cluster
              // @ts-ignore
              commonCluster = L.markerClusterGroup({
                spiderfyOnMaxZoom: true,
                showCoverageOnHover: false,
                iconCreateFunction: this.commonClusterIcon,
              });
              this.map.addLayer(commonCluster);
            }
            if (l.name === 'Scholen') {
              item['target'] = this.schoolMarkerCluster;
            } else {
              item['target'] = commonCluster;
            }
            legend.push(item);

            tagMap[key] = item.entities;
            this.flattenLegend.push(item);

            if (l.default_geom_type === 'PUNTAL') {

              const layers$ = this.dataService.getPublicEntitiesInLayer(l.checksum, l.layerID.id2, projectPath, projectId, projectIdOrScheme);
              let iconAnchor = L.point(28.5, 67);
              if (l.default_entity_type === 'COMMON' && l.name !== 'Scholen') {
                iconAnchor = L.point(16, 32);
              }
              entities$.push(layers$.pipe(
                catchError(() => of('err')),
                tap((result: any[] | string) => {
                  if (!Array.isArray(result)) {
                    if (result === 'err') {
                      console.log(result)
                    }
                  } else {
                    result.forEach(e => {
                      const attrs = Object.assign({ entityID: e.entityID }, { projectID: e.projectID }, e.genericAttributes.attributes);
                      const marker = this.commonMarker(attrs, key, iconAnchor, icon, e);
                      if (l.default_visible) {
                        if (l.name === 'Scholen') {
                          this.schoolMarkerCluster.addLayer(marker)
                        } else {
                          commonCluster.addLayer(marker)
                        }
                      }
                      tagMap[key].push(marker);
                    });
                  }
                })
              ));
            } else if (l.default_geom_type === 'LINEAL') {
              let routes$ = this.dataService.getPublicEntitiesInLayer(l.checksum, l.layerID.id2, projectPath, projectId, projectIdOrScheme);

              entities$.push(routes$.pipe(
                catchError(() => of('err')),
                tap((result: any[] | string) => {
                  if (!Array.isArray(result)) {
                    if (result === 'err') {
                      console.log(result)
                    }
                  } else {
                    result.forEach(s => {
                      let attrs = s.genericAttributes.attributes;

                      const hidden = attrs.invisible_in_project
                        && attrs.invisible_in_project.length > 0
                        && attrs.invisible_in_project.indexOf(this.projectId) >= 0;

                      let polyline = this.poly(attrs, (iconMap.style_line || {}).color, !hidden);
                      if (l.default_visible) {
                        polyline.addTo(this.map);
                      }
                      tagMap[key].push(polyline);
                    });
                  }
                })
              ));
            } else if (l.default_geom_type === 'POLYGONAL') {
              let polygons$ = this.dataService.getPublicEntitiesInLayer(l.checksum, l.layerID.id2, projectPath, projectId, projectIdOrScheme);

              entities$.push(polygons$.pipe(
                catchError(() => of('err')),
                tap((result: any[] | string) => {
                  if (!Array.isArray(result)) {
                    if (result === 'err') {
                      console.log(result)
                    }
                  } else {
                    result.forEach(s => {

                      let attrs = s.genericAttributes.attributes;

                      const coords = new Array();
                      attrs.geometry[0].coordinates[0].forEach(e => coords.push(e.reverse()));
                      coords.splice(coords.length - 1, 1);

                      const color = l.style_descriptor.style_polygon ? l.style_descriptor.style_polygon.color : '#bada55';

                      const polygon = L.polygon(coords, { color, weight: 2, fillOpacity: 0 });
                      if (l.default_visible) {
                        polygon.addTo(this.map);
                      }
                      tagMap[key].push(polygon);
                    });
                  }
                })
              ));
            }
          }
        });
        return combineLatest(entities$);
      })
    ).subscribe(
      () => {

      }
    );
  }

  getImgAbsoluteUrl(imgId) {
    if (imgId.indexOf('assets') != -1) return imgId;
    else return `${this.config.getHost()}/api2/public/image?image_id=${imgId}`;
  }

  getImgHostUrl(imgUrl) {
    return `${this.config.getProdHost()}${imgUrl}`;
  }

  updateByLegend() {
    this.flattenLegend.forEach(l => {
      l.entities.forEach(e => {
        if (l.target) l.target.removeLayer(e);
        else this.map.removeLayer(e);
        if (l.value) {
          if (l.target) l.target.addLayer(e);
          else this.map.addLayer(e);
        }
      })
    });
  }

  legendChanged(legend) {
    if ('children' in legend && legend.children.length) {
      legend.children.forEach(sl => sl.value = legend.value);
    }
    this.updateByLegend();
  }

  subLegendChanged(parent) {
    parent.value = parent.children.reduce((flag, sl) => flag && sl.value, true);
    this.updateByLegend();
  }

  private commonMarker(attrs: any, key, iconAnchor: L.Point, icon: string, entity: any) {
    const marker = L.marker(this.latLng(attrs.geometry[0].coordinates), {
      icon: L.icon({
        iconUrl: `assets/marker/${icon}`,
        iconAnchor,
      })
    });

    let markerDescription = '';
    let markerImg = '';
    if (key === "scholen") {
      if (attrs.name) {
        this.schoolData.push(entity);
        markerDescription = attrs.name[0];
      }
    } else {
      if (attrs.description && attrs.description[0]) {
        let description;
        try {
          description = JSON.parse(attrs.description[0]);
        } catch (e) {
          description = attrs.description[0];
        }
        if (_.isObject(description)) {
          const { info, img } = description;
          markerDescription = info;
          markerImg = img;
        } else {
          markerDescription = attrs.description;
        }
      }
    }

    marker.on('click', e => {
      if (this.oldActiveMarker && this.oldImgMarker) {
        this.oldActiveMarker.setIcon(L.icon({
          iconUrl: `assets/marker/${this.oldImgMarker}`,
          iconSize: this.oldMarkerIconSize,
          iconAnchor: this.oldMarkerIconAnchor
        }));
      }

      let school = '';
      try {
        school = this.projectId === attrs.projectID.id ? (this.projectData['projectData'] || {}).name : this.schoolData.find(e => e.genericAttributes.attributes.projectID[0].id === attrs.projectID.id).genericAttributes.attributes.name[0];
      } catch (error) {
        school = '';
      }

      this.commonMarkerPopup = Object.assign(
        {},
        attrs,
        { icon: `assets/marker/${icon}` },
        { projectName: school },
        { description: markerDescription },
        { img: markerImg }
      );
      this.commonPopupShown = true;
      this.popupShown = false;
      const myIcon = L.icon({
        iconUrl: `assets/marker/${icon}`,
        iconSize: [48, 48],
        iconAnchor: L.point(24, 48)
      });
      e.target.setIcon(myIcon);
      this.oldActiveMarker = e.target;
      this.oldImgMarker = icon;
      this.oldMarkerIconSize = [32, 32];
      this.oldMarkerIconAnchor = iconAnchor;
    });

    return marker;
  }

  private marker(attrs: any, icon: string, timestamp, isDefault = false) {
    const iconAnchor = isDefault ? L.point(16, 16) : L.point(23, 57);
    const marker = L.marker(this.latLng(attrs.geometry[0].coordinates), {
      status: attrs.status[0],
      icon: L.icon({
        iconUrl: `assets/img/${icon}`,
        iconAnchor
      })
    } as L.MarkerOptions);

    marker.on('click', e => {
      if (this.oldActiveMarker && this.oldImgMarker && this.oldMarkerIconSize && this.oldMarkerIconAnchor) {
        this.oldActiveMarker.setIcon(L.icon({
          iconUrl: `assets/img/${this.oldImgMarker}`,
          iconSize: this.oldMarkerIconSize,
          iconAnchor: this.oldMarkerIconAnchor
        }));
      }

      let school = '';
      try {
        school = this.projectId === attrs.projectID.id ? (this.projectData['projectData'] || {}).name : this.schoolData.find(e => e.genericAttributes.attributes.projectID[0].id === attrs.projectID.id).genericAttributes.attributes.name[0];
      } catch (error) {
        school = '';
      }

      this.markerPopup = Object.assign({}, attrs, { timestamp, icon: `assets/img/${icon}` }, { projectName: school });
      this.popupShown = true;
      this.commonPopupShown = false;
      const myIcon = L.icon({
        iconUrl: `assets/img/${icon}`,
        iconSize: [77, 92],
        iconAnchor: L.point(34, 67)
      });
      e.target.setIcon(myIcon);
      this.oldActiveMarker = e.target;
      this.oldImgMarker = icon;
      this.oldMarkerIconSize = [47, 57];
      this.oldMarkerIconAnchor = iconAnchor;
      this.selectedReport = attrs;
    });

    return marker;
  }

  openAttachModal(id) {
    const options: NgbModalOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      windowClass: 'attachImageModal'
    };

    const dlg = this.modalService.open(TicketImagesModalComponent, options);
    dlg.componentInstance.images = this.selectedReport.image;
    dlg.componentInstance.selectedID = id;
  }

  private poly(attr: any, color: string, visible = false) {
    const coords = attr.geometry[0].coordinates.map(coords => [coords[1], coords[0]]);
    return L.polyline(coords, {
      color,
      opacity: visible ? 1.0 : 0
    });
  }

  private latLng(ll) {
    return L.latLng(ll[1], ll[0]);
  }

  clusterIcon(cluster) {
    const markers = cluster.getAllChildMarkers();

    const types = [];

    markers.forEach(m => {
      const attr = m.options['status'];
      switch (attr) {
        case 'REPORTED':
          types[0] = 'r';
          break;
        case 'COMPLETED':
          types[1] = 'g';
          break;
        case 'PROCESSING':
          types[2] = 'b';
      }
    });

    const colorClass = types.join('');
    return L.divIcon({ html: markers.length, className: `cluster cluster-${colorClass}`, iconSize: L.point(47, 47) });
  }

  schoolClusterIcon(cluster) {
    const markers: Array<L.Marker> = cluster.getAllChildMarkers();
    return L.divIcon({ html: `<span class='badge badge-office'>${markers.length}</span>`, className: `cluster cluster-office`, iconSize: L.point(57, 67) });
  }

  commonClusterIcon(cluster) {
    const markers: Array<L.Marker> = cluster.getAllChildMarkers();
    let icon: L.Icon<L.IconOptions> | L.DivIcon = null;
    if (markers.length > 0) {
      const marker = markers[0];
      icon = marker.getIcon();
    }
    return L.divIcon({ html: `<img src="${icon && icon.options.iconUrl}"><span class='badge badge-common'>${markers.length}</span>`, className: `cluster cluster-common`, iconSize: L.point(32, 32) });
  }

  addHomeMarker() {
    let userLocation = this.userService.user.attributes.location[0].coordinates;
    var homeMarker = L.marker(new L.LatLng(userLocation[1], userLocation[0]), {
      icon: L.icon({ iconUrl: 'assets/marker/home.png', iconSize: [57, 67], iconAnchor: [27, 66] }),
      draggable: true
    });

    homeMarker.bindTooltip(`${this.userService.user.attributes.address[0].street} ${this.userService.user.attributes.address[0].houseNumber}`);

    this.map.addLayer(homeMarker);
  }

  expandTreeNode(node) {
    if (node.level === 0) {
      this.treeControl.dataNodes.forEach(e => {
        if (e !== node) {
          this.treeControl.collapse(e);
        }
      });
    }
  }

  initTypeahead() {
    const project_location = localStorage.getItem('project_location');
    this.address$ = concat(
      of([]),
      this.addressInput$.pipe(
        distinctUntilChanged(),
        tap(() => this.addressLoading = true),
        switchMap(term => {
          if (term) {
            let latlng;
            if (!project_location) { latlng = this.map.getCenter(); }
            else {
              const locations = project_location.split(',');
              var latitude = parseFloat(locations[1]),
                longitude = parseFloat(locations[0]);
              latlng = L.latLng(latitude, longitude);
            }
            return this.geocodingService.addressAutocomplete(term, latlng.lat, latlng.lng).pipe(
              catchError(() => of([])),
              map(result => {
                if (result.features) return result.features.map(r => Object.assign(r.properties, r.geometry));
                else return [];
              }),
              tap(() => this.addressLoading = false)
            );
          }
          this.addressLoading = false;
          // return of([]).pipe(
          //   map(() => this.addressLoading = false)
          // );
        })
      )
    );
  }

  findPos(latlng, type) {
    this.map.panTo({ lng: latlng.lon ? latlng.lon : latlng.lng, lat: latlng.lat });
    this.map.setZoom(18);

    if (type === 'start') {
      this.startPoint = latlng;
    }

    if (type === 'destination') {
      this.destinationPoint = latlng;
    }

    if (this.startPoint && this.destinationPoint) {
      this.searchRoute();
    }
  }

  onInputAddress(event, type = null) {
    if (event && event.coordinates) {
      const latlng = L.latLng(event.coordinates[1], event.coordinates[0]);
      this.findPos(latlng, type);
    } else if (event && event.name) {
      this.geocodingService.findPosition(event.name).subscribe(response => {
        if (response && response.lat) this.findPos(response, type);
      }, err => {
        const errDlg = this.modalService.open(ErrorModalComponent);
        errDlg.componentInstance.header = 'Unknown address';
        errDlg.componentInstance.message = 'The location of this address could not be determined. Please enter a new address.';
      });
    }
  }

  setTransportType(transportType) {
    if (transportType === this.transportType) {
      return;
    }

    if (!environment.production) {
      console.log("Route search transport type: " + transportType);
    }

    this.transportType = transportType;
    this.locateRouteControl();
  }

  extendMarker(i, waypoint, n) {
    if (i == 0 || i == n - 1)
      return null;

    return L.marker(waypoint.latLng, { icon: L.icon({ iconUrl: 'assets/marker/dot.png', iconSize: [19, 19] }), draggable: true });
  }

  routeLine(route, options) {
    let line = L.Routing.line(route, options);
    let tooltip = L.tooltip({ sticky: true, direction: 'top' }).setContent('Drag to route');
    line.eachLayer(l => { l.bindTooltip(tooltip) });
    return line;
  }

  locateRouteControl() {
    const ReversePlan: { new(waypoints, options?): any } & typeof L.Class = L.Routing.Plan.extend({
      reverseWaypoints: true,
      createGeocoders: () => {
        const container = L.Routing.Plan.prototype.createGeocoders.call(plan);
        // const reverseButton = createButton('↑↓', container);

        // L.DomEvent.on(reverseButton, 'click', () => {
        //   const waypoints = this.routing.getWaypoints();
        //   this.routing.setWaypoints(waypoints.reverse());
        // });
        return container;
      },
    });

    const plan = new ReversePlan([], {
      // createMarker: this.extendMarker.bind(this)
      geocoder: (L.Control as any).Geocoder.photon({
        serviceUrl: this.config.getPhotonServiceUrl(),
        reverseUrl: this.config.getPhotonReverseUrl(),
        geocodingQueryParams: this.getPhotonGeocodingQueryParamsProxy(),
        reverseQueryParams: this.geteversePhotonRQueryParamsProxy()
      }),
      geocoderPlaceholder: (index, numberWaypoints) => {
        const txt =
          index === 0 ?
            'Choose starting point, or click on the map'
            : index === numberWaypoints - 1 ? 'Choose destination...' : '';
        if (txt) {
          return this.translate.instant(txt);
        }
        return txt;
      },
      createGeocoder: (waypointIndex, numberWaypoints, plan) => {
        const geocoder =
          (L.Routing as any).GeocoderElement.prototype.options.createGeocoder.call(
            routing, waypointIndex, routing.getPlan().getWaypoints().length, (routing.getPlan() as any).options);

        const handle = L.DomUtil.create('mat-icon', 'geocoder-icon mat-icon material-icons');
        handle.innerHTML = waypointIndex === 0 ? "place" : waypointIndex === numberWaypoints - 1 ? "place" : "";
        handle.className = `geocoder-icon mat-icon material-icons ${waypointIndex === 0 ? "green_marker" : waypointIndex === numberWaypoints - 1 ? "red_marker" : ""}`;
        geocoder.container.insertBefore(handle, geocoder.container.firstChild);
        return geocoder;
      },
      createMarker: (waypointIndex, waypoint, numberWaypoints) => {
        let markerIcon = null;
        if (waypointIndex === 0) {
          markerIcon = L.icon({
            iconUrl: `assets/marker/marker-icon-green.png`,
            iconAnchor: L.point(15, 30)
          });
        } else if (waypointIndex === numberWaypoints - 1) {
          markerIcon = L.icon({
            iconUrl: `assets/marker/marker-icon-red.png`,
            iconAnchor: L.point(15, 30)
          });
        } else {
          markerIcon = L.icon({
            iconUrl: `assets/marker/dot.png`,
            iconAnchor: L.point(10, 19)
          });
        }
        return L.marker(waypoint.latLng, {
          draggable: true,
          icon: markerIcon
        });
      }
    });

    const routing: L.Routing.Control = new L.Routing.Control({
      autoRoute: false,
      show: true,
      plan,
      routeLine: this.routeLine,
      lineOptions: {
        styles: [{ color: '#0000b0', opacity: 1, weight: 5 }]
      },
      router: new L.Routing.OSRMv1((() => {
        let transportType = this.transportType;

        let serviceUrl: string;
        switch (transportType) {
          case 'foot':
          case 'bicycle':
            serviceUrl = `${this.appConfig.getSafeOsrmServiceUrl() + transportType}/route/v1`;
            break;
          default:
            serviceUrl = `${this.appConfig.getOsrmServiceUrl() + transportType}/route/v1`;
            break;
        }

        return {
          serviceUrl,
          routingOptions: {
            profile: transportType
          }
        };
      })()),
      fitSelectedRoutes: true,
    });

    plan.on('waypointschanged', e => {
      console.log('route');
      routing.route();
    });

    routing.on('routesfound', e => {
      console.log('extend-mode-routesfound');
    });

    if (this.routing) {
      routing.setWaypoints(this.routing.getWaypoints());
      this.routing.remove();
      this.routing = null;
    }
    routing.addTo(this.map);

    const routingControlContainer = routing.getContainer();
    const controlContainerParent = routingControlContainer.parentNode;
    controlContainerParent.removeChild(routingControlContainer);
    const itineraryDiv = document.getElementById('route-search-panel');
    itineraryDiv.appendChild(routingControlContainer);

    this.routing = routing;
  }

  searchRoute() {
    if (this.routing) {
      const waypoints = this.routing.getWaypoints();

      waypoints[0] = L.Routing.waypoint(this.startPoint);
      waypoints[1] = L.Routing.waypoint(this.destinationPoint);
      this.routing.setWaypoints(waypoints);
    }
  }

  private getPhotonGeocodingQueryParamsProxy() {
    const geocodingService = this.geocodingService;
    const handler = new class implements ProxyHandler<{}> {
      private params = geocodingService.getAddressAutocompleteParams();
      get(target: {}, p: PropertyKey, receiver: any): any {
        if (p == 'lang') {
          return geocodingService.getPhotonLangQueryParamValue();
        }
        return this.params[p];
      }

      getPrototypeOf(target: {}): object | null {
        return Object.getPrototypeOf(target);
      }

      ownKeys(target: {}): PropertyKey[] {
        return Object.keys(this.params);
      }

      getOwnPropertyDescriptor(target: {}, p: PropertyKey): PropertyDescriptor | undefined {
        return Object.getOwnPropertyDescriptor(this.params, p);
      }
    };

    return new Proxy({}, handler);
  }

  private geteversePhotonRQueryParamsProxy() {
    const geocodingService = this.geocodingService;
    const handler = new class implements ProxyHandler<{}> {
      private params = {
        lang: ''
      };

      get(target: {}, p: PropertyKey, receiver: any): any {
        if (p == 'lang') {
          return geocodingService.getPhotonLangQueryParamValue();
        }
        return this.params[p];
      }

      getPrototypeOf(target: {}): object | null {
        return Object.getPrototypeOf(target);
      }

      ownKeys(target: {}): PropertyKey[] {
        return Object.keys(this.params);
      }

      getOwnPropertyDescriptor(target: {}, p: PropertyKey): PropertyDescriptor | undefined {
        return Object.getOwnPropertyDescriptor(this.params, p);
      }
    };

    return new Proxy({}, handler);
  }

}
